import { sizes } from '@smartsheet/lodestar-core';

export const NODE_WIDTH = 384;
export const NODE_HEIGHT = 40;
export const HORIZONTAL_SPACING = 80;
export const VERTICAL_SPACING = 80;

export const PANEL_PADDING = sizes.large;
export const PANEL_WIDTH = 456;
export const PANEL_HEADER_HEIGHT = 24;
export const PANEL_HEADER_SPACE_BOTTOM = sizes.large;
export const RUNLOG_LIST_FILTER_HEIGHT = 40;
export const RUNLOG_LIST_FILTER_MARGIN_BOTTOM = sizes.medium;
export const RUNLOG_LIST_MARGIN_BOTTOM = sizes.small;
export const RUNLOG_LIST_PAGINATION_HEIGHT = 32;
export const PANEL_SPACE_TOP = 68;
export const PANEL_SPACE_BOTTOM = 16;
export const RUN_STATE_HEIGHT = 82;

export function getVerticalSpacingAroundRunLogList() {
  return (
    PANEL_PADDING * 2 +
    PANEL_HEADER_HEIGHT +
    PANEL_HEADER_SPACE_BOTTOM +
    RUNLOG_LIST_FILTER_HEIGHT +
    RUNLOG_LIST_MARGIN_BOTTOM +
    RUNLOG_LIST_FILTER_MARGIN_BOTTOM +
    RUNLOG_LIST_PAGINATION_HEIGHT +
    PANEL_SPACE_BOTTOM +
    PANEL_SPACE_TOP
  );
}

export function getVerticalSpacingAroundRunSteps() {
  return (
    PANEL_PADDING * 2 +
    PANEL_HEADER_HEIGHT +
    PANEL_HEADER_SPACE_BOTTOM +
    RUN_STATE_HEIGHT +
    PANEL_SPACE_BOTTOM +
    PANEL_SPACE_TOP
  );
}
